export const LOCAL_STORAGE_KEY_NAME = 'cart_items';

export const addItem = (itemId: number): void => {
    try {
        const stringifiedCartItems = localStorage.getItem(LOCAL_STORAGE_KEY_NAME);
        if (!!stringifiedCartItems) {
            const cartItems: number[] = JSON.parse(stringifiedCartItems);
            if (!cartItems.find((id) => id === itemId)) localStorage.setItem(LOCAL_STORAGE_KEY_NAME, JSON.stringify([...cartItems, itemId]));
        }
        else localStorage.setItem(LOCAL_STORAGE_KEY_NAME, JSON.stringify([itemId]));
    } catch (e) {
        console.error(e)
    }
};

export const removeItem = (itemId: number): void => {
    try {
        const stringifiedCartItems = localStorage.getItem(LOCAL_STORAGE_KEY_NAME);
        if (!!stringifiedCartItems) {
            const cartItems: number[] = JSON.parse(stringifiedCartItems);
            localStorage.setItem(LOCAL_STORAGE_KEY_NAME, JSON.stringify(cartItems.filter((id) => id !== itemId)));
        }
    } catch (e) {
        console.error(e)
    }
};

export const setItems = (itemIds: number[]): void => {
    try {
        localStorage.setItem(LOCAL_STORAGE_KEY_NAME, JSON.stringify(itemIds));
    } catch (e) {
        console.error(e)
    }
};

export const getNumberOfItems = (): number => {
    try {
        const stringifiedCartItems = localStorage.getItem(LOCAL_STORAGE_KEY_NAME);
        if (!!stringifiedCartItems) {
            const cartItems = JSON.parse(stringifiedCartItems);
            return cartItems.length;
        }
    } catch (e) {
        console.error(e)
    }
    return 0;
};
